export const GAIL_API = process.env.NEXT_PUBLIC_GAIL_API || "";

/**
 * Galactus internal API base URL for migrated GAIL endpoints
 */
export const GALACTUS_INTERNAL_API = `${GAIL_API}/.internal`;

export const GAIL_WORKFLOWS_API = process.env.NEXT_PUBLIC_GAIL_WORKFLOWS_API || "";

export const RACCOON_API = process.env.NEXT_PUBLIC_GAIL_RACOON_URL || "";

export const CAL_DOT_COM_API = process.env.NEXT_PUBLIC_CALCOM_API_URL || "";

export const AUTH0_TOKEN_USER_ID_KEY = `${process.env.NEXT_PUBLIC_AUTH_TOKEN_HOST}/user_id`;

// ---------------------------------------------------------------------------
// Route classification — single source of truth used by the customers layout,
// authz, and auth-seed.ts to keep product routing and permission checks in sync.
// ---------------------------------------------------------------------------

/** Forwarded by `src/proxy.ts` so server layouts can read the request path. */
export const GAIL_PATHNAME_HEADER = "x-gail-pathname";

export const GET_GAIL_PATH = "/get-gail";

/** Routes accessible to any authenticated user regardless of product role */
export const AUTH_ONLY_PREFIXES = ["/profile", GET_GAIL_PATH, "/not-found", "/unauthorized"] as const;

/** Routes that require the GailAgent product role */
export const GAIL_AGENT_PREFIXES = ["/calls", "/partners", "/outbound", "/inbound", "/conversations"] as const;

/** Routes that require the GailGPT product role */
export const GAIL_GPT_PREFIXES = ["/gailgpt", "/history"] as const;

export function isAuthOnlyRoute(path: string): boolean {
  return AUTH_ONLY_PREFIXES.some((r) => path.startsWith(r));
}

export function isGailAgentRoute(path: string): boolean {
  if (path === "/") return true;
  return GAIL_AGENT_PREFIXES.some((r) => path.startsWith(r));
}

export function isGailGptRoute(path: string): boolean {
  return GAIL_GPT_PREFIXES.some((r) => path.startsWith(r));
}

/** Path of one workflow's canvas editor. */
export function workflowBuilderPath(workflowId: string): string {
  return `/workflows/${encodeURIComponent(workflowId)}/builder`;
}

/** The canvas editor of one workflow, where the GailGPT dock edits that workflow. */
export function workflowBuilderRouteId(path: string): string | null {
  const match = /^\/workflows\/([^/]+)\/builder\/?$/.exec(path);
  return match ? decodeURIComponent(match[1]) : null;
}

export function isProductRoute(path: string): boolean {
  return isGailAgentRoute(path) || isGailGptRoute(path);
}

export function shouldRedirectToGetGail(
  pathname: string,
  agencyId: string | undefined | null
): boolean {
  return !agencyId && isProductRoute(pathname);
}

export enum PUBLIC_API_ROUTES {
  AUTH_GET_STARTED = "/api/public/onboarding/get-started",
  SETUP_AGENCY = "/api/public/onboarding/setup-agency",
  SETUP_AGENCY_UPDATE_CONTACT = "/api/public/onboarding/update-contact",
}
